import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-us',
  templateUrl: 'contact-us.component.html',
  styleUrls: ['contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  public sectionTitle: string = "Contattaci";
  public sectionDescription: string ="More to come...";

  constructor() { }

  ngOnInit() {
  }

  openEmails():void {
    window.location.href = "mailto:info@joinonboard.eu?subject=Info%20Request&body=Hi%20Team,%20I%20need%20some%20info.";
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpage/sections/contact-us/contact-us.component.ts